// extracted by mini-css-extract-plugin
var _1 = "j0XVr";
var _2 = "RqYbU";
var _3 = "To0Q4";
var _4 = "_Z7Ww";
var _5 = "_9a28f";
var _6 = "fkQ8H";
var _7 = "BdGUJ";
var _8 = "UdhPj";
var _9 = "L85T1";
export { _1 as "canvas-wrapper", _2 as "draw-signature", _3 as "placeholder", _4 as "placeholder-icon", _5 as "signature", _6 as "signature-option", _7 as "signature-option-icon", _8 as "text-signature-canvas", _9 as "text-signature-input" }
